import api from '@/api/api';

const ENDPOINT = 'panel';

class PanelService {

    getTeachers() {
        return api().get(`/${ENDPOINT}/teacher`);
    }

    getBranches(selectedTeacher) {
        if (!selectedTeacher) {
            return Promise.resolve({data: []});
        }
        return api().get(`/${ENDPOINT}/teacher/branch?teacher_username=${selectedTeacher.username}`);
    }

    getCourseTypes() {
        return api().get(`/${ENDPOINT}/course-type`);
    }

    getClasses(selectedTeacher, selectedBranches, selectedCourseTypes) {
        if (!selectedTeacher) {
            return Promise.resolve({data: []});
        }

        let url = `/${ENDPOINT}/teacher/class?teacher_username=${selectedTeacher.username}`

        for (const branch in selectedBranches) {
            url += `&branch_id=${selectedBranches[branch].id}`
        }

        for (const courseType in selectedCourseTypes) {
            url += `&course_type_id=${selectedCourseTypes[courseType].id}`
        }

        return api().get(url);
    }

    fetchData(students, selectedPeriod, selectedLaboratories) {
        if (students.length === 0 || !selectedPeriod) {
            return Promise.resolve({
                data: {
                    students: [],
                    totalStudents: 0,
                    averageExercisesPerStudent: 0,
                    averageTimePerExercise: 0,
                    errorDistribution: [],
                    exercises: [],
                    performanceDistributionPerStudent: [],
                }
            });
        }

        const studentsParams = students.map(s => `students=${encodeURIComponent(s.username)}`).join('&');
        let queryString = `${studentsParams}&dateFrom=${selectedPeriod.values.from}&dateTo=${selectedPeriod.values.to}`;

        if (selectedLaboratories && selectedLaboratories.length > 0) {
            const labParams = selectedLaboratories.map(l => `laboratory_id=${l.id}`).join('&');
            queryString += `&${labParams}`;
        }

        return api().get(`/panel/data?${queryString}`);
    }

    downloadSpreadsheet(students, selectedPeriod) {
        const studentsParams = students.map(s => `register_ids=${encodeURIComponent(s.register_id)}`).join('&');
        const queryString = `${studentsParams}&dateFrom=${selectedPeriod.values.from}&dateTo=${selectedPeriod.values.to}`;

        return api().get(`/${ENDPOINT}/download?${queryString}`, {responseType: 'blob'});
    }

    updateExerciseThreshold(exerciseId, thresholdSeconds) {
        return api().patch(`/exercise/${exerciseId}/threshold`, {
            threshold_seconds: parseInt(thresholdSeconds, 10)
        });
    }

    getLaboratories() {
        return api().get('/laboratory');
    }
}

export default new PanelService();